import { GridWrapper } from "./ImageGrid.styled";
import classNames from "classnames";
import { useCallback } from "react";
import { ProductLabels } from "../ProductLabels";
import { ProductLabel } from "src/types/graphql.d";
import { useImageCarouselDispatch } from "src/hooks/context/use-image-carousel-context";
import { GridImage } from "./GridImage";

type ImageGridProps = {
  photos: string[];
  labels?: ProductLabel[];
  productName: string;
  setIsZoomOpen: (isZoomOpen: boolean) => void;
};

function ImageGrid({
  photos,
  labels,
  productName,
  setIsZoomOpen,
}: ImageGridProps): JSX.Element {
  const imageCarouselDispatch = useImageCarouselDispatch();
  const handleImageClick = useCallback(
    (index: number) => {
      setIsZoomOpen(true);
      imageCarouselDispatch({
        type: "SET_SELECTED_IMAGE_INDEX",
        payload: {
          selectedImageIndex: index,
          updateIdentifier: "zoom",
        },
      });
    },
    [setIsZoomOpen, imageCarouselDispatch]
  );

  return (
    <GridWrapper
      className={classNames({
        ["two-by-two"]: photos.length % 4 === 0 || photos.length % 2 === 0,
        ["two-by-one"]:
          photos.length === 3 || photos.length === 5 || photos.length === 7,
        ["two-by-three"]: photos.length === 8,
      })}
    >
      {photos.map((photo, index) => (
        <GridImage
          key={`pdp-${productName}-${index}`}
          photo={photo}
          productName={productName}
          index={index}
          handleImageClick={handleImageClick}
        >
          {labels && index === 0 ? (
            <div className="labels-wrapper">
              <ProductLabels labels={labels} />
            </div>
          ) : null}
        </GridImage>
      ))}
    </GridWrapper>
  );
}

export { ImageGrid };
